import { Routers } from './Routers';
import { PageMeta, ContextLayout } from 'Elements';
import { ToastContainer } from 'react-toastify';
import 'scss/app.scss';

const App = () => {
	return (
		<ContextLayout>
			<PageMeta
				defaultTitle="قصه شهر"
				titleTemplate={`%s - قصه شهر`}
				defer={false}
			/>
			<Routers />
			<ToastContainer rtl limit="1" />
		</ContextLayout>
	);
};

export default App;
